import type { AxiosInstance } from '@b2ag/axios'
import { createAxiosClientWithAladinBearer } from '@b2ag/axios'
import { buildCallerId } from '@b2ag/utils/src/caller-id'
import type { IUserTechnicalSalesRepository } from '../../domain/repository/IUserTechnicalSalesRepository'
import { i18n } from '@b2ag/locale'

export class UserTechnicalSalesRepository implements IUserTechnicalSalesRepository {
  api: AxiosInstance

  constructor(apiHost: string) {
    this.api = createAxiosClientWithAladinBearer(`${apiHost}/v1`, { callerId: buildCallerId(), i18n })
  }

  async sendProductInfoRequest(partnerId: string, technicianId: string, payload: any) {
    const response = await this.api.post(`/partners/${partnerId}/technicians/${technicianId}/contact`, payload)
    return response.data
  }
}
